export enum WaiveType {
  INTEREST = 'INTEREST',
  PAST_DUE_INTEREST = 'PAST_DUE_INTEREST',
  PENALTY = 'PENALTY',
  CBU = 'CBU',
  TP = 'TP',
  PF = 'PF',
  CUSTOM_FEE = 'CUSTOM_FEE'
}

export interface WaiveInput {
  waiveType: WaiveType;
  waiveAmount: number;
  feeDefinitionId?: number;
  loanId: number;
}
